import ReducedDesktopNavigation from '@components/components/ReducedNavigation/components/ReducedDesktopNavigation/ReducedDesktopNavigation';
import ReducedMobileNavigation from '@components/components/ReducedNavigation/components/ReducedMobileNavigation/ReducedMobileNavigation';
import { useMedia } from '@components/hooks';
import React from 'react';

const ReducedNavigation = () => {
  const isMobile = useMedia('(max-width: 767px)');

  return isMobile ? <ReducedMobileNavigation /> : <ReducedDesktopNavigation />;
};

export default ReducedNavigation;
